module.exports = __webpack_public_path__ + "img/team_8.02d928fb.jpg";